<template>
  <div class="live_streaming_list_container">
    <div class="header">
      <div class="header_left">
        <a-select
          :default-value="''"
          placeholder="学校"
          style="width: 200px"
          @change="handleSchoolChange"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option :value="item.value" v-for="item in schoolList" :key="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
        <a-select
          :default-value="''"
          placeholder="状态"
          style="width: 130px; margin-left: 16px"
          @change="handleStatusChange"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option :value="item.value" v-for="item in liveStreamingStatusOptions" :key="item.value">
            {{ item.title }}
          </a-select-option>
        </a-select>
        <a-range-picker
          :placeholder="rangePicker"
          format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD"
          separator="至"
          v-model="momentDate"
          style="width: 278px; margin-left: 16px"
          @change="handleRangePickerChange"
        >
          <a-icon slot="suffixIcon" type="calendar" />
        </a-range-picker>
        <a-input
          v-model:value="searchKeywords"
          placeholder="请输入直播、主讲关键字"
          @keyup.enter="handleSearchKeywords"
          style="margin-left: 16px"
        >
          <template #suffix>
            <img
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png"
              alt="搜索"
              style="cursor: pointer"
              @click="handleSearchKeywords"
            />
          </template>
        </a-input>
      </div>
      <div class="header_right">
        <a-button type="primary" class="add_course_btn ZHIHUISHU_QZMD" @click="toggleCreateLiveModal(true, 'add')">
          <a-icon type="plus-circle" theme="filled" />
          创建直播
        </a-button>
      </div>
    </div>
    <div class="count_box">
      <div>
        直播数：
        <span>{{ pagination.total || 0 }}</span>
      </div>
    </div>
    <div class="body">
      <a-table
        :columns="liveStreamingColumns"
        :data-source="liveStreamingList"
        :pagination="pagination"
        :loading="loading"
        :row-key="(record) => record.liveId"
        @change="handleTableChange"
        :customRow="customRow"
      >
        <div slot="username" slot-scope="text, record" class="username">
          <a-tooltip
            placement="topLeft"
            :title="`${record.username}（${record.phone || '- -'}）`"
            :overlayStyle="{ width: 'auto' }"
          >
            <span>{{ record.username }}</span>
          </a-tooltip>
        </div>
        <div slot="classroomName" slot-scope="text, record" class="classroom_name">
          <a-tooltip placement="topLeft" :title="`${record.classroomNameAll}`" :overlayStyle="{ width: 'auto' }">
            <span>{{ record.classroomName || '- -' }}</span>
          </a-tooltip>
        </div>
        <div slot="directors" slot-scope="text, record" class="directors">
          {{ record.directors || '- -' }}
        </div>
        <div slot="liveStatus" slot-scope="text, record" class="live_status">
          <div class="status_box to_be_started" v-if="record.liveStatus === 0">待开始</div>
          <div class="status_box under_way" v-if="record.liveStatus === 1">进行中</div>
          <div class="status_box finished" v-if="record.liveStatus === 2">已结束</div>
        </div>
        <div slot="action" slot-scope="text, record" class="action_box">
          <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>导播</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/video.png"
              alt="video"
              class="action_box_item"
              @click.stop="handleAction(record, 'instructorInBroadcasting')"
            />
          </a-tooltip>
          <!-- <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>回放</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/liveBack.png"
              alt="liveBack"
              class="action_box_item"
              v-if="record.liveStatus === 2"
              @click.stop="handleAction(record, 'liveBack')"
            />
          </a-tooltip> -->
          <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>分享</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/share.png"
              alt="share"
              class="action_box_item"
              @click.stop="handleAction(record, 'share')"
            />
          </a-tooltip>
          <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>编辑</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/edit.png"
              alt="edit"
              class="action_box_item"
              @click.stop="handleAction(record, 'edit')"
            />
          </a-tooltip>
          <a-tooltip placement="top" :overlayStyle="{ width: '45px' }">
            <template slot="title">
              <span>删除</span>
            </template>
            <img
              src="@/assets/img/liveStreaming/delete.png"
              alt="delete"
              class="action_box_item"
              @click.stop="handleAction(record, 'delete')"
            />
          </a-tooltip>
        </div>
      </a-table>
    </div>
    <!-- share -->
    <share-dialog :shareDialogFlag.sync="shareDialogFlag" :rowDetail="rowDetail" />
    <!-- edit -->
    <create-live-modal
      :liveDetail="liveEditDetail"
      :schoolList="checkedSchool"
      :showModal="showCreateLiveModal"
      @refresh="refresh"
      @close="toggleCreateLiveModal"
    />
    <!-- delete -->
    <!-- <delete-dialog
    :deleteDialogFlag.sync="deleteDialogFlag"
    :rowDetail="rowDetail"
    @refresh="refresh" /> -->
    <DeleteDialog
      :showDelDialogProp.sync="deleteDialogFlag"
      delTitle="删除直播"
      tipText="确认要删除此直播吗？"
      @handleDel="handleDel"
    />
    <!-- play back -->
    <play-back
      @hideMaskForDrawer="drawerFlag = false"
      :drawerFlag="drawerFlag"
      ref="refForPlayBack"
      :drawerVideoSrc="drawerVideoSrc"
    />
  </div>
</template>

<script>
import DateUtil from '@/utils/getDate.js'
import { editLiveDisplayInfo } from '@/server/api/courseManage'
import { checkRes } from '@/utils/tool'
export default {
  name: 'LiveStreamingList',
  components: {
    'share-dialog': () => import('./comp/ShareDialog.vue'),
    'create-live-modal': () => import('../comp/createCourse/CreateLiveModal'),
    'delete-dialog': () => import('./comp/DeleteDialog.vue'),
    DeleteDialog: () => import('@/views/BasicData/BuildingManagement/components/delDailog.vue'),
    'play-back': () => import('@/components/playback/index.vue')
  },
  data() {
    return {
      schoolList: [],
      schoolCode: '',
      liveStreamingStatusOptions: [
        {
          title: '直播状态',
          value: ''
        },
        {
          title: '待开始',
          value: 0
        },
        {
          title: '进行中',
          value: 1
        },
        {
          title: '已结束',
          value: 2
        }
      ],
      liveStatus: '',
      rangePicker: ['开始时间', '结束时间'],
      momentDate: [DateUtil.getNowDay(), DateUtil.getNowDay()],
      searchKeywords: '',
      liveStreamingColumns: [
        {
          title: '状态',
          dataIndex: 'liveStatus',
          key: 'liveStatus',
          scopedSlots: { customRender: 'liveStatus' },
          align: 'left'
        },
        {
          title: '直播名称',
          dataIndex: 'liveName',
          key: 'liveName',
          scopedSlots: { customRender: 'liveName' },
          align: 'left'
        },
        {
          title: '直播时间',
          dataIndex: 'liveTime',
          key: 'liveTime',
          scopedSlots: { customRender: 'liveTime' },
          align: 'left'
        },
        {
          title: '主讲学校',
          dataIndex: 'schoolName',
          key: 'schoolName',
          scopedSlots: { customRender: 'schoolName' },
          align: 'left'
        },
        // {
        //   title: '主讲老师',
        //   dataIndex: 'username',
        //   key: 'username',
        //   scopedSlots: { customRender: 'username' },
        //   align: 'left'
        // },
        {
          title: '教室',
          dataIndex: 'classroomName',
          key: 'classroomName',
          scopedSlots: { customRender: 'classroomName' },
          align: 'left'
        },
        {
          title: '导播人员',
          dataIndex: 'directors',
          key: 'directors',
          scopedSlots: { customRender: 'directors' },
          align: 'left'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'right',
          width: '80px'
        }
      ],
      liveStreamingList: [],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['50', '100', '150', '200'],
        showTotal: (total) => `共 ${total} 条`
      },
      loading: false,
      // share
      shareDialogFlag: false,
      rowDetail: {},
      // edit
      liveEditDetail: {},
      checkedSchool: [],
      showCreateLiveModal: false,
      // delete
      deleteDialogFlag: false,
      // play back
      drawerFlag: false,
      drawerVideoSrc: ''
    }
  },
  methods: {
    handleSchoolChange(value) {
      this.schoolCode = value
      this.getLiveStreamingList()
    },
    handleStatusChange(value) {
      this.liveStatus = value
      this.getLiveStreamingList()
    },
    handleRangePickerChange() {
      this.getLiveStreamingList()
    },
    handleSearchKeywords() {
      this.getLiveStreamingList()
    },
    async getSchoolList() {
      try {
        const result = await this.$http.getSelectSchoolList()
        if (result.code !== 200) return
        const schoolList = (result.rt || []).map((item) => {
          item.title = item.schoolName
          item.value = item.schoolId
          return item
        })
        this.checkedSchool = JSON.parse(JSON.stringify(schoolList))
        this.schoolList = JSON.parse(JSON.stringify(schoolList))
        this.schoolList.unshift({
          title: '全部学校',
          value: ''
        })
      } catch (err) {
        console.log(err)
      }
    },
    async getLiveStreamingList() {
      try {
        if (!this.momentDate.length) return this.$message.error('请选择日期')
        const params = {
          schoolCodes: [],
          liveStatus: this.liveStatus,
          startTime: this.momentDate[0],
          endTime: this.momentDate[1],
          keywords: this.searchKeywords,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        if (this.schoolCode) {
          Object.assign(params, {
            schoolCodes: [this.schoolCode]
          })
        }
        this.loading = true
        const result = await this.$http.searchLiveByPage(params)
        this.loading = false
        const { rt: resultReally } = result
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage || '抱歉，获取直播列表失败')
        this.liveStreamingList = (resultReally.list || []).map((item) => {
          let date = item.startTime.split(' ')[0].replace(/-/g, '/')
          let startTime = item.startTime.split(' ')[1].slice(0, 5)
          let endTime = item.endTime.split(' ')[1].slice(0, 5)
          let liveTime = date + ' ' + startTime + '-' + endTime
          item.liveTime = liveTime
          item.directors = (item.directors || []).join('、')
          item.classroomNameAll = [`${item.classroomName}（主讲）`].concat(item.watchClassrooms || []).join('、')
          return item
        })
        this.pagination.total = resultReally.totalCount
      } catch (err) {
        console.log(err)
      }
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getLiveStreamingList()
    },
    handleAction(record, action) {
      this.rowDetail = record
      const { videoId, liveId, virtualLiveId } = record
      switch (action) {
        case 'instructorInBroadcasting':
          let guideStationPath = this.$router.resolve({
            path: '/guideStation',
            query: {
              liveId: virtualLiveId ? virtualLiveId : liveId
            }
          })
          window.open(guideStationPath.href, '_blank')
          break
        case 'liveBack':
          // this.backVideoPlay(videoId ? [videoId] : [])
          this.backVideoPlay(videoId)
          break
        case 'share':
          this.shareDialogFlag = true
          break
        case 'edit':
          this.getLiveEditDetail(record.liveId)
          break
        case 'delete':
          this.deleteDialogFlag = true
          break
      }
    },
    // 打开直播弹窗
    toggleCreateLiveModal(bl, option) {
      if (option === 'add') {
        this.liveEditDetail = {}
      }
      this.showCreateLiveModal = bl
    },
    // 获取直播可编辑详情
    async getLiveEditDetail(liveId) {
      const self = this
      const res = await editLiveDisplayInfo({ liveId })
      checkRes({
        res,
        success(data) {
          self.liveEditDetail = data.rt
          self.toggleCreateLiveModal(true, 'edit')
        },
        failed() {
          self.$message.error('获取课程详情失败')
        }
      })
    },
    async refresh() {
      await this.getLiveStreamingList()
    },
    customRow(record, index) {
      return {
        on: {
          click: (event) => {
            this.rowClick(record, index, event)
          }
        }
      }
    },
    async rowClick(record, index, event) {
      const { classroomCode, liveStatus, liveId = '', videoId, mscId } = record
      switch (liveStatus) {
        case 0:
        case 1:
          if (classroomCode) {
            this.$router.push({
              name: 'InspectionTourDetail',
              query: {
                liveId,
                classroomCode
              }
            })
          } else {
            // window.open(`https://tju-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`, '_blank')
            window.open(`https://zhs-livecourse.zhihuishu.com/teacher/IndividualStudent?liveId=${liveId}`, '_blank')
          }
          break
        case 2:
          // this.backVideoPlay(videoId ? [videoId] : [])
          // this.backVideoPlay(videoId)
          const role = '0'
          // const href = `https://tju-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          const href = `https://zhs-livecourse.zhihuishu.com/primary/#/playback?mscId=${mscId}&id=${liveId}&role=${role}`
          window.open(href, '_blank')
          break
      }
    },
    // get video
    getVideoUrl(videoId) {
      return new Promise(async (resolve, reject) => {
        const result = await this.$http.getVideoInfo({ videoId })
        if (result.code !== 200) return this.$message.error('抱歉，获取回放失败')
        const videoSrc = result.rt.storage || ''
        const videoImage = result.rt.thumbnail || ''
        if (videoSrc) {
          resolve({
            videoSrc,
            videoImage
          })
        } else {
          reject('暂无视频')
        }
      })
    },
    // play back
    // async backVideoPlay(videoId) {
    //   if (!videoId.length)
    //     return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
    //   this.$nextTick(async () => {
    //     let videoSrcList = []
    //     let videoImageList = []
    //     for (let i = 0, len = videoId.length; i < len; i++) {
    //       try {
    //         const { videoSrc, videoImage } = await this.getVideoUrl(videoId[i])
    //         // const videoSrc = 'http://vjs.zencdn.net/v/oceans.mp4'
    //         videoSrcList.push(videoSrc)
    //         videoImageList.push(videoImage)
    //       } catch (err) {
    //         console.log(err, 'err')
    //       }
    //     }
    //     if (videoSrcList.length) {
    //       const refForPlayBack = this.$refs.refForPlayBack
    //       refForPlayBack.options.src = videoSrcList[0]
    //       refForPlayBack.options.poster = videoImageList[0] || require('../../../assets/img/myVideo/the_fist.png')
    //       refForPlayBack.options.sectionList = videoSrcList
    //         .map((item, index) => {
    //           return {
    //             key: `${index + 1}`,
    //             value: `第${index + 1}节`,
    //             videoUrl: item
    //           }
    //         })
    //         .reverse()
    //       refForPlayBack.options.sectionActive =
    //         refForPlayBack.options.sectionList[refForPlayBack.options.sectionList.length - 1].key
    //       this.drawerFlag = true
    //     }
    //   })
    // }
    // play back
    async backVideoPlay(videoId) {
      if (!videoId) return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      const { videoSrc, videoImage } = await this.getVideoUrl(videoId)
      if (!videoSrc) return this.$message.error('课程结束1小时后生成回放，请稍后重试！如有问题请联系智慧树运维客服！')
      this.drawerVideoSrc = videoSrc
      this.drawerFlag = true
    },
    async handleDel() {
      try {
        const result = await this.$http.deletedLive(this.rowDetail.liveId)
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        this.deleteDialogFlag = false
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
        this.$message.success('删除成功')
        this.refresh()
      } catch (err) {
        console.log(err)
      }
    }
  },
  async created() {
    await this.getSchoolList()
    this.getLiveStreamingList()
  }
}
</script>

<style lang="scss" scoped>
.live_streaming_list_container {
  width: 100%;
  height: auto;
  text-align: left;
  .header {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    .header_left {
      position: relative;
      ::v-deep.ant-input-affix-wrapper {
        width: 240px;
        .ant-input-suffix {
          img {
            width: 20px;
            height: 20px;
            display: block;
          }
        }
      }
    }
    .header_right {
      ::v-deep.ant-btn-primary {
        background-color: #5f60d3;
        border-color: #5f60d3;
      }
    }
  }
  .count_box {
    height: 60px;
    line-height: 60px;
    display: flex;
    > div {
      margin-right: 15px;
      > span {
        color: #5f60d3;
        font-weight: bold;
      }
    }
  }
  .body {
    width: 100%;
    height: auto;
    background-color: #ffffff;
    // margin-top: 16px;
    padding: 16px;
    .live_status {
      .status_box {
        width: 52px;
        height: 20px;
        border-radius: 2px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        &.to_be_started {
          border: 1px solid #1572ff;
          color: #1572ff;
        }
        &.under_way {
          border: 1px solid #1fcc9c;
          color: #1fcc9c;
        }
        &.finished {
          border: 1px solid #9ca5b1;
          color: #9ca5b1;
        }
      }
    }
    .action_box {
      width: 120px;
      display: flex;
      justify-content: flex-end;
      .action_box_item {
        display: block;
        width: 16px;
        height: 16px;
        margin-right: 12px;
        cursor: pointer;
        &:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
